<template>
  <div class="row-card-title left">
    <div @click="setTabTittleColor('queuing')">
      <div :class="getTabTittleColor(activeState.queuing)">Queuing</div>
      <template v-if="activeState.queuing">
        <div class="line" />
      </template>
    </div>
    <div @click="setTabTittleColor('archive')">
      <div :class="getTabTittleColor(activeState.archive)">Archive</div>
      <template v-if="activeState.archive">
        <div class="line" />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "bannerlisttab",
  data() {
    return {
      activeState: { queuing: true, archive: false }
    };
  },
  methods: {
    getTabTittleColor(status) {
      switch (status) {
        case true:
          return "card-title-active";
        case false:
          return "card-title";
      }
    },
    setTabTittleColor(state) {
      switch (state) {
        case "queuing":
          this.activeState = { queuing: true, archive: false };
          break;
        case "archive":
          this.activeState = { queuing: false, archive: true };
          break;
      }
    }
  }
};
</script>